import React from "react";
import { Container, Typography, Grid, Box, Card, CardContent, CardActions, Button, CardMedia } from "@mui/material";
import { Link } from "react-router-dom";
import { articles } from "../data/articles";
import { Article as ArticleIcon } from "@mui/icons-material";

const ArticlesPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, py: 4 }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom color="primary">
          Artigos
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Notícias e instruções sobre segurança digital, privacidade e senhas seguras.
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {articles.map((article) => (
          <Grid item xs={12} sm={6} md={4} key={article.id}>
            <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              {article.image && <CardMedia component="img" height="140" image={article.image} alt={article.title} />}
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  {article.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {article.summary}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" component={Link} to={`/articles/${article.id}`}>
                  Ler Mais
                </Button>
                <Box sx={{ flexGrow: 1 }} />
                <Typography variant="caption" color="text.secondary">
                  {article.date}
                </Typography>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ArticlesPage;
